export interface Localization {
  nameEn: string;
  nameKz: string;
  nameRu: string;
}
